import { createFileRoute } from "@tanstack/react-router";
import AdminLinkAudit from "@/pages/AdminLinkAudit";

export const Route = createFileRoute("/admin/link-audit/")({
  component: AdminLinkAudit,
});
